import * as React from 'react';
import {TextBody} from './TextBody';

export type Props = {
  template: string;
  templatePairs?: {
    [key: string]: string;
  };
};

export const TaskBody: React.FC<Props> = (props) => {
  const {template, templatePairs} = props;

  const generatedTemplate = React.useMemo(() => {
    let finalTemplate = template;

    if (!templatePairs) {
      return finalTemplate;
    }

    Object.entries(templatePairs).forEach(([key, value]) => {
      const isLink = value.includes('stripe.com');
      const regex = isLink ? new RegExp(key, 'g') : new RegExp(`{${key}}`, 'g');
      finalTemplate = finalTemplate.replace(regex, value);
    });

    return finalTemplate;
  }, [template, templatePairs]);

  return (
    <TextBody
      body={generatedTemplate}
      css={{
        fontSize: 12,
        lineHeight: 16,
      }}
    />
  );
};
